import React from "react";
import { Switch } from "react-router-dom";
import { connect } from "react-redux";
import PrivateRoute from "components/common/PrivateRoute";
import QuestionLibrary from "components/menu/master-files/question-library/list";

const ReportBuilderRouter = props => (
    <div className="px-5">
        <Switch>
            <PrivateRoute
                exact
                path={`${props.match.url}/`}
                component={QuestionLibrary}
            />
        </Switch>
    </div>
);

export default connect()(ReportBuilderRouter);
